import { apiClient } from './api';

export type CustomerSegment = 'all' | 'vip' | 'new' | 'inactive' | 'repeat' | 'churned';
export type CustomerSortBy = 'createdAt' | 'totalSpent' | 'orderCount' | 'lastOrderDate';

export interface CustomerQuery {
  page?: number;
  limit?: number;
  search?: string;
  segment?: CustomerSegment;
  sortBy?: CustomerSortBy;
}

export interface CustomerProfile {
  id: string;
  email: string;
  name: string | null;
  surname: string | null;
  phone: string | null;
  createdAt: string;
  totalSpent: number;
  orderCount: number;
  avgOrderValue: number;
  lastOrderDate: string | null;
  favoriteRestaurants: Array<{ restaurantId: string; restaurantName: string; orderCount: number }>;
  favoriteCategories: Array<{ categoryName: string; orderCount: number }>;
  addresses: Array<{ id: string; title: string; fullAddress: string }>;
  reviews: Array<{ id: string; rating: number; comment: string | null; createdAt: string }>;
}

export interface CustomerListResponse {
  customers: CustomerProfile[];
  total: number;
  page: number;
  limit: number;
}

export interface CustomerSegments {
  vip: number;
  new: number;
  inactive: number;
  repeat: number;
  churned: number;
}

export const adminCustomerService = {
  async listCustomers(query: CustomerQuery): Promise<CustomerListResponse> {
    const response = await apiClient.get<CustomerListResponse>('/admin/customers', {
      params: query,
    });
    return response.data.data;
  },

  async getCustomerDetails(customerId: string): Promise<CustomerProfile> {
    const response = await apiClient.get<CustomerProfile>(`/admin/customers/${customerId}`);
    return response.data.data;
  },

  async getCustomerOrders(customerId: string, page: number = 1, limit: number = 20) {
    const response = await apiClient.get(`/admin/customers/${customerId}/orders`, {
      params: { page, limit },
    });
    return response.data.data;
  },

  async getCustomerSegments(): Promise<CustomerSegments> {
    const response = await apiClient.get<CustomerSegments>('/admin/customers/segments/counts');
    return response.data.data;
  },

  async getCustomerAnalytics(period: 'week' | 'month' | 'year' = 'month') {
    const response = await apiClient.get('/admin/customers/analytics/overview', {
      params: { period },
    });
    return response.data.data;
  },

  async getRFMAnalysis() {
    const response = await apiClient.get('/admin/customers/analytics/rfm');
    return response.data.data;
  },
};
